<template>
  <div>{{ data.text}}</div>
</template>

<script>
import ScormService from '@/services/scorm/scorm.js';
export default {
  name: 'Note',
  props: ['data', 'standard'],
  methods: {
    saveSCORMInteraction() {
      const scormData = {
        id: this.$attrs.id,
        type: this.$attrs.type,
        isCorrect: 'n/a',
        answer: 'n/a',
        description: this.data.text,
      };
      ScormService.saveSCORMInteraction(scormData);
    },
  },
  mounted() {
    if (this.standard === 'SCORM_2004') {
      this.saveSCORMInteraction();
    }
  },
};
</script>
